import "./index.css";
import App from "./app";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { DISABLE_SERVICE_WORKER } from "@/constants";
import { NetworkStatusProvider } from "@/hooks/index";
import { registerServiceWorker } from "./serviceWorkerRegistration";
import KeepAlive from "react-activation";
import { maybeApplyForcedCacheReset } from "@/shared/maybeApplyForcedCacheReset";
import {
  migrateLegacyIdbCritical,
  scheduleLegacyIdbHeavyMigration,
} from "@/shared/legacyIdb";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

(KeepAlive as any).defaultProps = {
  ...(KeepAlive as any).defaultProps,
  autoFreeze: false,
};

/**
 * A migração crítica dos bancos IndexedDB antigos vem **antes** do reset forçado, e o reset antes do
 * primeiro render.
 *
 * Carrinhos e pedidos offline são o único dado do app que não existe em nenhum outro lugar: se o
 * primeiro render acontecer antes de eles voltarem, o RCA vê um carrinho vazio que não esvaziou. E
 * antes do reset porque o reset limpa o `localStorage` — onde ficam os marcadores da migração.
 */
const boot = async () => {
  try {
    await migrateLegacyIdbCritical();
  } catch (error) {
    // Falhar aqui não pode impedir o app de subir: os bancos antigos seguem no disco, com os dados,
    // e a próxima abertura tenta de novo (nenhum marcador foi gravado).
    console.error("[boot] migração crítica do IndexedDB legado falhou:", error);
  }

  if (await maybeApplyForcedCacheReset()) {
    window.location.reload();
    return;
  }

  root.render(
    //<React.StrictMode>
    <NetworkStatusProvider>
      <App />
    </NetworkStatusProvider>
    //</React.StrictMode>
  );

  if (!DISABLE_SERVICE_WORKER) registerServiceWorker();
  reportWebVitals();

  // Fase pesada (apagar os datasets antigos, copiar as imagens) só depois que a tela já está de pé.
  scheduleLegacyIdbHeavyMigration();
};

void boot();

